module.exports = __webpack_public_path__ + "static/synergx-logo-7f778eb1785d56ccc70f627128cbb603.png";